module.exports = __webpack_public_path__ + "img/illu-step5-nobrain.91e1c9b6.svg";